import React, { useEffect, useState } from "react";
import ComponentContainer from "../../components/ComponentContainer";
import UserMenu from "../../components/UserMenu/UserMenu";
import SmallComponentHeading from "../../components/Headings/SmallComponentHeading";
import Button from "../../components/Button";
import { ReactComponent as SortSvg } from "../../assets/svg/sort.svg";
import { ReactComponent as PlusSquareSvg } from "../../assets/svg/plus_square.svg";
import "../../css/my-storage.css";
import DinosaurCard from "../../components/DinosaurCard";
import dailyImg from "../../assets/img/case/daily.png";
import BusterImg from "../../assets/img/busters/buster.png";
import EggImg1 from "../../assets/img/eggs/spinosaur.png";
import EggImg2 from "../../assets/img/eggs/puertosaur.png";
import MegaCommon from "../../components/MegaProfile/MegaCommon";
import {
  dinosaurSizes,
  initialCookieOptions,
  megaShopTypes,
  pageNames,
} from "../../utils/consts";
import { usePageName } from "../../hooks/usePageName";
import userStore from "../../store/userStore";
import { v4 as uuidv4 } from "uuid";
import MyLink from "../../components/MyLink";
import { paths } from "../../paths";
import { useCookies } from "react-cookie";
import { apiHelpers } from "../../utils/apiHelpers";
import { catalogCategoriesEng } from "../../utils/megaShopItemsData";
import { observer } from "mobx-react-lite";
import { fetchWithAbort } from "../../utils/fetchWithAbort";

const MyStorage = () => {
  const [cookie, setCookie, removeCookie] = useCookies();

  usePageName(pageNames.MegaProfile);
  const [storageItems, setStorageItems] = useState(userStore.storage || []);
  const [cases, setCases] = useState([]);
  const [busters, setBusters] = useState([]);
  const [eggs, setEggs] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        await fetchWithAbort(
          (signal) => apiHelpers.getAndSetUserStorage(0, signal),
          signal
        );
      } catch (err) {
        console.error(err);
      }
    })();

    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    setCases(
      storageItems.filter(
        (item) => item.shopItem.category === catalogCategoriesEng.items
      )
    );
    // setBusters(
    //   storageItems.filter((item) => item.shopItem.type === megaShopTypes.buster)
    // );
    // setEggs(storageItems.filter((item) => item.shopItem.type === megaShopTypes.egg));
  }, [storageItems]);

  useEffect(() => {
    setStorageItems(userStore.storage);
  }, [userStore.storage]);

  // const cases = {
  //   image: dailyImg,
  // };
  // const busters = {
  //   image: BusterImg,
  // };
  // const eggs = [
  //   {
  //     image: EggImg1,
  //   },
  //   {
  //     image: EggImg2,
  //   },
  // ];
  return (
    <div className="my-storage-page page mega-profile-page">
      <MegaCommon>
        <div className="my-storage">
          <SmallComponentHeading className="flex svg-text">
            <span>Хранилище</span>
            <div className="buttons">
              <Button className="no-background border-extra spiked">
                <SortSvg /> СОРТИРОВАТЬ
              </Button>
              <Button className="no-background border-extra spiked">
                <PlusSquareSvg /> КУПИТЬ ДИНОЗАВРОВ
              </Button>
            </div>
          </SmallComponentHeading>
          <div className="my-storage-container">
            <SmallComponentHeading>Кейсы</SmallComponentHeading>
            {/* изменить индексы на id из-за динамического рендера */}
            <div className="cases flex-container">
              {cases.map((item, i) => (
                <DinosaurCard
                  key={`cases-${item.shopItem?.id}`}
                  data={item.shopItem}
                  size={dinosaurSizes.normal}
                  isBuyable={false}
                />
              ))}
              {cases.length === 0 && (
                <p>
                  Тут пока ещё пусто, но вы можете приобрести кейсы в{" "}
                  <MyLink to={paths.MegaShop}>МегаШопе</MyLink>
                </p>
              )}
            </div>
            <SmallComponentHeading>Бустеры</SmallComponentHeading>
            <div className="busters flex-container">
              {busters.map((item, i) => (
                <DinosaurCard
                  key={`busters-${item.shopItem?.id}`}
                  data={item.shopItem}
                  size={dinosaurSizes.normal}
                />
              ))}
              {busters.length === 0 && (
                <p>
                  Тут пока ещё пусто, но вы можете приобрести бустеры в{" "}
                  <MyLink to={paths.MegaShop}>МегаШопе</MyLink>
                </p>
              )}
            </div>
            <SmallComponentHeading>Яйца</SmallComponentHeading>
            <div className="eggs flex-container">
              {eggs.map((item, i) => (
                <DinosaurCard
                  key={`eggs-${item.shopItem?.id}`}
                  data={item.shopItem}
                  size={dinosaurSizes.normal}
                />
              ))}
              {eggs.length === 0 && (
                <p>
                  Тут пока ещё пусто, но вы можете приобрести яйца в{" "}
                  <MyLink to={paths.MegaShop}>МегаШопе</MyLink>
                </p>
              )}
            </div>
          </div>
        </div>
      </MegaCommon>
    </div>
  );
};

export default observer(MyStorage);
